<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                <template v-for="subscription in subscriptions">
                    <v-flex v-bind:key="subscription['.key']" xs12>
                        <v-card color="blue-grey darken-2" class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ subscription.firstName }} {{ subscription.lastName }} {{seatPresentation(subscription)}}</h3>
                                    <div>{{subscription.street}}{{subscription.street && subscription.postalCode ? "," : ""}} {{subscription.postalCode}} {{subscription.city}}</div>
                                </div>
                            </v-card-title>
                            <v-card-actions>
                                <v-btn flat dark @click="() => { editSubscription(subscription) }">Bewerken</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn flat color="red" @click="() => { deleteSubscription(subscription) }">Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
        <v-btn
                fab
                bottom
                right
                color="pink"
                dark
                fixed
                @click.stop="() => {selectedSubscription = null; dialog = !dialog}"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <SubscriptionDialog :dialog="dialog" v-on:closeDialog="dialog = false" :selectedSubscription="selectedSubscription"/>
    </v-content>
</template>

<script>
import { db } from "../../firebase";
import SubscriptionDialog from "../components/SubscriptionDialog";

export default {
  components: { SubscriptionDialog },
  name: "Subscriptions",
  props: {
    msg: String
  },
  data() {
    return {
      subscriptions: [],
      dialog: false,
      selectedSubscription: null
    };
  },
  firestore() {
    const today = new Date();
    let lastmonth = new Date();
    lastmonth.setDate(today.getDate() - 30);

    return {
      subscriptions: db
        .collection("subscriptions")
        .orderBy("tribuneBlock")
        .orderBy("tribuneRow")
        .orderBy("tribuneSeat")
    };
  },
  methods: {
    deleteSubscription: function(subscription) {
      if (confirm("Ben je zeker?")) {
        db.collection("subscriptions")
          .doc(subscription[".key"])
          .delete();
      }
    },
    editSubscription: function(subscription) {
      this.selectedSubscription = subscription;
      this.dialog = !this.dialog;
    },
    seatPresentation: function(subscription) {
      let tribunePrice = "";
      if (subscription.tribunePrice && subscription.tribunePrice === "gratis") {
        tribunePrice = " " + subscription.tribunePrice;
      } else if (subscription.tribunePrice) {
        tribunePrice = " € " + subscription.tribunePrice;
      }
      if (subscription.tribuneRow && subscription.tribuneSeat) {
        return (
          "(" +
          subscription.tribuneBlock +
          " " +
          subscription.tribuneRow +
          "/" +
          subscription.tribuneSeat +
          tribunePrice +
          ")"
        );
      } else if (subscription.tribuneSeat) {
        return (
          "(" +
          subscription.tribuneBlock +
          " " +
          subscription.tribuneSeat +
          tribunePrice +
          ")"
        );
      }

      return "";
    }
  }
};
</script>
